// Predefined content frameworks
export const FRAMEWORKS = {
  AIDA: "Attention, Interest, Desire, Action",
  PAS: "Problem, Agitation, Solution",
  STAR: "Situation, Task, Action, Result",
  FAB: "Features, Advantages, Benefits",
  "4 Ps": "Promise, Picture, Proof, Push",
} as const;